var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:("echart-" + _vm._uid),staticClass:"chart",attrs:{"id":("echart-" + _vm._uid)}})}
var staticRenderFns = []

export { render, staticRenderFns }